const BLOCKED_AVATAR_HOST_PATTERNS = [
  "via.placeholder.com",
];

export function isUsableAvatarUrl(url?: string | null): boolean {
  if (!url || typeof url !== "string") return false;
  const trimmed = url.trim();
  if (!trimmed) return false;

  const lower = trimmed.toLowerCase();
  return !BLOCKED_AVATAR_HOST_PATTERNS.some((blocked) => lower.includes(blocked));
}
